var _require = require('../utils/utils'),
    fixedEncodeURIComponent = _require.fixedEncodeURIComponent;

module.exports = function (sparqlEndpoint) {
  return function (sparql) {
    var query = fixedEncodeURIComponent(sparql);
    return "".concat(sparqlEndpoint, "?format=json&query=").concat(query);
  };
};